module.exports = "https://coursera_assets.s3.amazonaws.com/images/cb2e069d08d8632d92da90ac5ccee651.png";